import React from 'react'

import { Dropdown } from 'ui'

import { t } from 'translations'

const ButtonSubmitAnother = ({ values, actions, onSubmit }) => {
  return (
    <>
      <Dropdown.Toggle color="primary" id="creation-dropdown" />
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={async () => {
            const errors = Object.keys(await actions.validateForm())
            if (errors.length) for (const field of errors) actions.setFieldTouched(field, true, true)
            else onSubmit(values, actions, true)
          }}
        >
          {t(`SUBMIT_AND_CREATE_OTHER`)}
        </Dropdown.Item>
      </Dropdown.Menu>
    </>
  )
}

export default ButtonSubmitAnother
